// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Use BrowserRouter
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navigation/Navigation'; // Updated to match your import
import Home from './components/Home/Home';
import EmailTemplates from './components/EmailTemplates/EmailTemplates';
import Websites from './components/Websites/Websites';
import Services from './components/Services/Services';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ScrollToTop from './ScrollToTop';
import ScrollToTopButton from './components/ScrollToTop/ScrollToTop';
import QuickContact from './components/QuickContact/QuickContact';
import TestCode from './components/TestCode/TestCode';

import './App.css';


const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="app-container">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/email-templates" element={<EmailTemplates />} />
            <Route path="/websites" element={<Websites />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/test-code" element={<TestCode />} />
          </Routes>
          <Footer />
        </div>
        <ScrollToTopButton />
        <QuickContact />
      </Router>
    </HelmetProvider>
  );
};

export default App;